import { LinearProgress as MuiLinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinearProgress = styled(MuiLinearProgress)(
  ({ theme: { palette, spacing } }) => ({
    height: spacing(2),
    borderRadius: spacing(2),
    backgroundColor: palette.grey[200],
  }),
);
